"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _sortablejs = _interopRequireDefault(require("sortablejs"));

//
//
//
//
//
//
//
//
var _default = {
  data: function data() {
    return {};
  },
  props: ['tableData', 'dropCol', 'col'],
  mounted: function mounted() {
    console.log(this.tableData, this.dropCol);
    this.rowDrop();
    this.columnDrop();
  },
  methods: {
    // 行拖拽
    rowDrop: function rowDrop() {
      var tbody = document.querySelector('.el-table__body-wrapper tbody');

      var _this = this;

      _sortablejs.default.create(tbody, {
        onEnd: function onEnd(_ref) {
          var newIndex = _ref.newIndex,
              oldIndex = _ref.oldIndex;

          var currRow = _this.tableData.splice(oldIndex, 1)[0];

          _this.tableData.splice(newIndex, 0, currRow);
        }
      });
    },
    // 列拖拽
    columnDrop: function columnDrop() {
      var _this2 = this;

      var wrapperTr = document.querySelector('.el-table__header-wrapper tr');
      this.sortable = _sortablejs.default.create(wrapperTr, {
        animation: 180,
        delay: 0,
        handle: ".allowDrag",
        // 格式为简单css选择器的字符串，使列表单元中符合选择器的元素成为拖动的手柄，只有按住拖动手柄才能使列表单元进行拖动
        filter: ".noDrag",
        // 过滤器，不需要进行拖动的元素
        preventOnFilter: true,
        //  在触发过滤器`filter`的时候调用`event.preventDefault()`
        draggable: ".allowDrag",
        // 允许拖拽的项目类名
        onEnd: function onEnd(evt) {
          var oldItem = _this2.dropCol[evt.oldIndex - 1] - num是多少列被禁止;

          _this2.dropCol.splice(evt.oldIndex - 1, 1);

          _this2.dropCol.splice(evt.newIndex - 1, 0, oldItem);
        }
      });
    }
  }
};
exports.default = _default;